"use client";

import { useCompositeGroup } from "../__chunks/ENWWPSY3.js";
import "../__chunks/T75KQT4U.js";
import "../__chunks/7HVFURXT.js";
import { useComboboxScopedContext } from "../__chunks/3LH6HMTR.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/combobox/combobox-group.tsx
import { getPopupRole } from "@ariakit/core/utils/dom";
import { invariant } from "@ariakit/core/utils/misc";
var TagName = "div";
var useComboboxGroup = createHook(function useComboboxGroup2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useComboboxScopedContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "ComboboxRow must be wrapped in a ComboboxList or ComboboxPopover component");
  var contentElement = store.useState("contentElement");
  var popupRole = getPopupRole(contentElement);
  if (popupRole === "grid") {
    props = __spreadValues({
      role: "rowgroup"
    }, props);
  }
  props = useCompositeGroup(__spreadValues({
    store: store
  }, props));
  return props;
});
var ComboboxGroup = forwardRef(function ComboboxGroup2(props) {
  var htmlProps = useComboboxGroup(props);
  return createElement(TagName, htmlProps);
});
export { ComboboxGroup, useComboboxGroup };